module.exports = __webpack_public_path__ + "img/btc.9dd29a99.png";